// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__AU0F8","item":"Navbar_item__3kxkM","active":"Navbar_active__1xoaX"};